// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3q-2";
export var blackBorderOnHover = "_3q-7";
export var cell = "_3q-6";
export var cellContainer = "_3q-3";
export var checked = "_3q-8";
export var disabled = "_3q-5";
export var featuredIconCellContainer = "_3q-9";
export var featuredIconTextContainer = "_3q-b";
export var featuredIconWrapper = "_3q-a";
export var noBorder = "_3q-c";
export var orangeSelectedRow = "_bs-3";
export var overflowableText = "_3q-0";
export var overflowableTextContainer = "_3q-1";
export var row = "_3s-0";
export var rowCheckboxCell = "_3q-4";
export var selectableTable = "_bs-2";